// src/Components/Formpage/Formpage.js
import React, { useState } from 'react';
import './formpage.css';
import axios from 'axios';
import { useNavigate} from "react-router-dom";

const designData = [
  { name: 'Website' },
  { name: 'Logo Design' },
  { name: 'Customized Website' },
  { name: 'SEO(Search Engine Optimization)' },
  { name: 'Social Media' },
  { name: 'Digital Marketing' },
  { name: 'E-invitation' },
];

function Formpage({ show, onClose }) {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [selectedInvitation, setSelectedInvitation] = useState('');

  const navigate = useNavigate();

  if (!show) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      email,
      name,
      phone,
      invitationType: selectedInvitation,
    };

    try {
      const response = await axios.post('https://electiaa.com/php/send_mail.php', formData);
      // alert(response.data.message);
      navigate('/thankyou');
      setEmail('');
      setName('');
      setPhone('');
      setSelectedInvitation('');
      onClose();
    } catch (error) {
      console.error('Error sending mail:', error);
      alert('Failed to send enquiry. Try again later.');
    }
  };

  return (
    <div className="popup-backdrop">
      <div className="wrapper-1 popup-card">
        <button className="btn-close-popup" onClick={onClose}>&times;</button>
        <form onSubmit={handleSubmit}>
          <h2>Get Enquiry</h2>

          <div className="input-field">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            <label>Enter your Email</label>
          </div>

          <div className="input-field">
            <input type="text" required value={name} onChange={(e) => setName(e.target.value)} />
            <label>Enter your Name</label>
          </div>

          <div className="input-field">
            <input type="number" required value={phone} onChange={(e) => setPhone(e.target.value)} />
            <label>Enter your Phone Number</label>
          </div>

          <div className="input-field">
            <select value={selectedInvitation} onChange={(e) => setSelectedInvitation(e.target.value)} required>
              <option value="" disabled>Select Service</option>
              {designData.map((item, idx) => (
                <option key={idx} value={item.name}>{item.name}</option>
              ))}
            </select>
          </div>

          <button type="submit" className="btn btn-success mt-3">Submit</button>
        </form>
      </div>
    </div>
  );
}

export default Formpage;
